/**
 * Fields that must NOT be carried over when duplicating an item.
 * Covers system identifiers, audit metadata, lifecycle/workflow state,
 * and Aras versioning. Both snake_case (Aras wire format) and camelCase
 * (DTO format) variants are listed because records may arrive in either.
 */
export const DUPLICATE_EXCLUDED_FIELDS: ReadonlySet<string> = new Set([
  "id",
  "item_number",
  "itemNumber",
  "keyed_name",
  "keyedName",
  "created_on",
  "createdOn",
  "modified_on",
  "modifiedOn",
  "created_by_id",
  "createdById",
  "createdByIdDisplay",
  "modified_by_id",
  "modifiedById",
  "modifiedByIdDisplay",
  "locked_by_id",
  "lockedById",
  "lockedByIdDisplay",
  "owned_by_id",
  "ownedById",
  "ownedByIdDisplay",
  "managed_by_id",
  "managedById",
  "managedByIdDisplay",
  "permission_id",
  "permissionId",
  "permissionIdDisplay",
  "config_id",
  "configId",
  "configIdDisplay",
  "is_current",
  "isCurrent",
  "current_state",
  "currentState",
  "currentStateDisplay",
  "previous_state",
  "previousState",
  "previousStateDisplay",
  "state",
  "team_id",
  "teamId",
  "teamIdDisplay",
  "is_released",
  "isReleased",
  "new_version",
  "newVersion",
  "major_rev",
  "majorRev",
  "minor_rev",
  "minorRev",
  "generation",
  "not_lockable",
  "notLockable",
  "_relationships",
  "relationships",
  "Relationships",
]);

/**
 * Strip system / auto-generated fields from a record so it can be used as
 * `initialValues` for the create form when duplicating. The new record
 * keeps user-editable values only — Aras and the backend re-generate ids,
 * timestamps, lifecycle state, and ownership on save.
 */
export function sanitizeForDuplicate(
  source: Record<string, unknown> | null | undefined,
): Record<string, unknown> {
  if (!source) return {};

  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(source)) {
    if (DUPLICATE_EXCLUDED_FIELDS.has(key)) continue;
    if (value === null || value === undefined) continue;
    result[key] = value;
  }
  return result;
}
